// Cyphr.me Home page.
"use strict";

import * as App from '../app/app~fv=cw_byBD8.min.js';
import QrScanner from '../pkg/qr-scanner.min.js'

// Page Modals
var scanQRModal;

App.AddOnload(SearchOnload);

/**
SearchOnload
@returns {void}
 */
function SearchOnload() {
	document.querySelector('#searchBtn').addEventListener('click', function (e) {
		window.location = "/search/" + document.querySelector("#searchFormInput").value;
	});

	// Modals
	let modalOpts = {
		keyboard: true
	};
	scanQRModal = new bootstrap.Modal(document.getElementById('scanQRModal'), modalOpts);


	///////////////////////////
	// QR scanning modal.  
	const searchInput = document.querySelector("#searchFormInput");
	document.querySelector(".scanQRBtn").addEventListener("click", (item) => {
		console.log("Start scan QR");
		scanQRModal.toggle();
		let videoElem = document.getElementById("scanQRVideo");

		const qrScanner = new QrScanner(
			videoElem,
			result => scanQRCallback(result), {
				highlightScanRegion: true,
			},
		);

		function scanQRCallback(result) {
			console.log('decoded qr code:', result);
			scanQRModal.toggle();
			console.log(result.data);
			searchInput.value = result.data;
			// searchInput.dispatchEvent(new Event('input')); // Actually trigger event on input.
			document.querySelector('#searchBtn').dispatchEvent(new Event('click'));
		}

		// Stop scanning when the modal is closed.  (The bootstrap modal object is
		// not the html element, so select it by ID. )
		document.getElementById('scanQRModal').addEventListener('hidden.bs.modal', event => {
			qrScanner.stop();
		});

		qrScanner.start();
	});

};